import { ArrowBackIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './newEventHeader.module.scss';

export const NewEventHeader = ({ handlerArrowLeftButton }) => (
    <div className={styles['container']}>
        <div onClick={handlerArrowLeftButton} className={styles['icon']}>
            <ArrowBackIcon />
        </div>
        <div className={styles['title']}>
            <FormattedMessage id="codeless.new.event.header" defaultMessage="New event" />
        </div>
    </div>
);
